import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : undefined, withCredentials: true });

export const hasBackend = Boolean(BASE);

export function formatApiError(err, fallback = "Ocorreu um erro. Por favor, tente novamente.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.response ? fallback : "Não foi possível contactar o servidor. Verifique a sua ligação.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
  return fallback;
}
